import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { employeedetailsdirectreports } from '../../../interface/delegationofauthority/employeedetails';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-lookup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './lookup.component.html',
  styleUrls: ['./lookup.component.css'],
})
export class LookupComponent implements OnChanges {
  @ViewChild('lookupModal') lookupModal: any;
  @Output() selectedResult = new EventEmitter<string>();
  @Input() initialEmail: string = '';
  @Input() clearSearch: boolean = false;
  @Input() HideLookUpSearchButton: boolean = false;
  mainSearchText: string = '';
  modalSearchText: string = '';
  results: any[] = [];

  constructor(private commonService: CommonService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['initialEmail'] && this.initialEmail) {
      this.mainSearchText = this.initialEmail;
    }
    if (changes['clearSearch'] && this.clearSearch) {
      this.mainSearchText = '';
      this.clearSearch = false; 
    }
  }
  openLookup() {
    this.lookupModal.nativeElement.style.display = 'block';
  }

  closeLookup() {
    this.lookupModal.nativeElement.style.display = 'none';
  }

  search() {
    if (this.modalSearchText.length >= 4) {
      this.commonService
        .getEmployeeDetails(this.modalSearchText)
        .subscribe((response: any) => {
          if (response && Array.isArray(response.value)) {
            this.results = response.value;
          } else {
            this.results = [];
          }
        });
    } else {
      this.results = [];
    }
  }

  selectResult(event: Event, item: any) {
    event.preventDefault();
    this.mainSearchText = `${item.preferredName} (${item.emailAddress})`;
    this.selectedResult.emit(item);
    this.closeLookup();
  }
}
